<ng-template #titleTpl>
    <span *ngIf="!editMode && estimation.costEstimationTypeId === standardCostEstimationType">
        {{'claims-center.claimCostEstimations.addCostEstimation' | translate}}</span>
    <span *ngIf="!editMode && estimation.costEstimationTypeId === additionalCostEstimationType">
        {{'claims-center.claimCostEstimations.addAdditionalCostEstimation' | translate}}</span>

    <div *ngIf="editMode && estimation.costEstimationTypeId === standardCostEstimationType">
        <span>
            {{'claims-center.claimCostEstimations.manageCostEstimation' | translate}}
        </span>
        <strong> {{estimation.carBrand}} {{estimation.carModel}} - {{estimation.carPlateNumber}}
            ({{estimation.claimNumber}})</strong>
    </div>

    <div *ngIf="editMode && estimation.costEstimationTypeId === additionalCostEstimationType">
        <span>
            {{'claims-center.claimCostEstimations.manageAdditionalCostEstimation' | translate}}
        </span>
        <strong> {{estimation.carBrand}} {{estimation.carModel}} - {{estimation.carPlateNumber}}
            ({{estimation.claimNumber}})</strong>
    </div>
</ng-template>

<ng-template #actionsTpl>
    <button kendoButton (click)="cancel()" [disabled]="isProcessing">{{'global.cancel' | translate}}</button>
    <button kendoButton (click)="confirm()" [disabled]="isProcessing" [primary]="true" submit>
        <span *ngIf="editMode  && !isProcessing">{{'global.save' | translate}}</span>
        <span *ngIf="!editMode  && !isProcessing">{{'global.add' | translate}}</span>
        <app-loading-panel [isLoading]="isProcessing" [size]="'small'"></app-loading-panel>
    </button>
</ng-template>

<ng-container *ngIf="estimationForm">

<kendo-dialog-titlebar *ngIf="dialog">
    <ng-container *ngTemplateOutlet="titleTpl"></ng-container>

    <div *ngIf="editMode">
         <button kendoButton look="flat" (click)="showInExternalWindow(estimation.id)"> 
            <img src="./assets/img/external_window.png" [width]="16" alt="external-window" />
        </button>
    </div>

</kendo-dialog-titlebar>

<h3 *ngIf="!dialog">
    <ng-container *ngTemplateOutlet="titleTpl"></ng-container>
</h3>


<form [formGroup]="estimationForm">
    <app-cost-estimation-form [form]="estimationForm"></app-cost-estimation-form>
</form>

<kendo-dialog-actions *ngIf="dialog">
    <ng-container *ngTemplateOutlet="actionsTpl"></ng-container>
</kendo-dialog-actions>

<div *ngIf="!dialog" class="k-dialog-buttons k-dialog-actions k-actions k-actions-stretched standalone-actions">
    <ng-container *ngTemplateOutlet="actionsTpl"></ng-container>
</div>

</ng-container>